import React from "react";
import { Play } from "lucide-react";

interface VideoDemoProps {
  title: string;
  videoSrc?: string;
}

const VideoDemo: React.FC<VideoDemoProps> = ({ title, videoSrc }) => {
  return (
    <div className="relative w-full h-full max-w-2xl mx-auto">
      <div className="relative rounded-2xl overflow-hidden bg-gray-800/50 border border-gray-700/50 shadow-xl">
        {videoSrc ? (
          <div className="w-full h-80 relative">
            <video
              className="w-full h-full object-cover"
              style={{ zIndex: 10 }}
              autoPlay
              loop
              muted
              playsInline
              preload="auto"
            >
              <source src={videoSrc} type="video/webm" />
              <div className="w-full h-full bg-gradient-to-br from-gray-800 to-gray-900 flex items-center justify-center">
                <div className="text-center space-y-4">
                  <div className="w-20 h-20 mx-auto rounded-full bg-gray-700 flex items-center justify-center">
                    <Play className="w-10 h-10 text-gray-400 ml-1" />
                  </div>
                  <div className="space-y-2">
                    <h3 className="text-xl font-bold text-white">{title}</h3>
                    <p className="text-gray-400">Video not supported</p>
                  </div>
                </div>
              </div>
            </video>
          </div>
        ) : (
          <div className="w-full h-80 bg-gradient-to-br from-gray-800 to-gray-900 flex items-center justify-center">
            <div className="text-center space-y-4">
              <div className="w-20 h-20 mx-auto rounded-full bg-gray-700 flex items-center justify-center">
                <Play className="w-10 h-10 text-gray-400 ml-1" />
              </div>
              <div className="space-y-2">
                <h3 className="text-xl font-bold text-white">{title}</h3>
                <p className="text-gray-400">Demo Video Coming Soon</p>
              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default VideoDemo;